(() => {
  'use strict';
  const closeMenus = () => document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.open = false; });
  document.addEventListener('click', event => {
    const categoryLink = event.target.closest('[data-enquiry]');
    if (categoryLink) {
      const contact = document.getElementById('contact');
      const select = contact?.querySelector('[data-garment-select]');
      if (select && contact) {
        const interest = categoryLink.dataset.enquiry;
        let option = [...select.options].find(item => item.value === interest);
        if (!option) { option = new Option(interest, interest); select.add(option); }
        select.value = interest;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        event.preventDefault();
        history.replaceState(null, '', '#contact');
        contact.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        select.focus({ preventScroll: true });
      }
    }
    if (event.target.closest('.mobile-menu a')) closeMenus();
    document.querySelectorAll('.mobile-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const menu = document.querySelector('.mobile-menu[open]');
      if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
    }
  });
  const formMessage = document.querySelector('.form-message');
  if (formMessage && (/contact/i.test(location.hash) || location.search.includes('contact_posted'))) {
    formMessage.focus({ preventScroll: true });
    formMessage.scrollIntoView({ block: 'center' });
  }
})();

(() => {
  'use strict';
  const seenKey = 'crew-order-popup-seen-v1';
  const pendingKey = 'crew-order-popup-pending-v1';
  const readSession = key => { try { return sessionStorage.getItem(key); } catch (_) { return null; } };
  const writeSession = (key, value) => { try { value === null ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, value); } catch (_) { /* The form still works without storage. */ } };

  function initOrderPopup(root) {
    const dialog = root.querySelector('[data-order-popup]');
    const panel = root.querySelector('.launch-enquiry .launch-form-panel');
    if (!dialog || !panel || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
    dialog.dataset.ready = 'true';
    const slot = dialog.querySelector('[data-order-popup-form]');
    const form = panel.querySelector('form');
    const home = document.createComment('Order enquiry form home');
    panel.before(home);
    let opener = null;
    let autoTimer = null;
    let hasOpened = false;
    let backdropStart = false;
    let captchaWatchTimer = null;
    let captchaHandoff = false;
    const triggers = [...root.querySelectorAll('[data-order-popup-trigger]')];
    triggers.forEach(trigger => {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
    });

    // hCaptcha inserts its challenge beside the page, outside our native dialog.
    // Close only our dialog when that challenge is visible; never move or alter it.
    function visibleCaptchaChallenge() {
      return [...document.querySelectorAll('iframe[title="hCaptcha challenge"], iframe[src*="hcaptcha.com"][src*="frame=challenge"]')].find(frame => {
        let source;
        try { source = new URL(frame.getAttribute('src'), location.href); } catch (_) { return false; }
        if (!/(^|\.)hcaptcha\.com$/i.test(source.hostname)) return false;
        if (frame.title !== 'hCaptcha challenge' && new URLSearchParams(source.hash.slice(1)).get('frame') !== 'challenge') return false;
        const bounds = frame.getBoundingClientRect();
        if (!frame.getClientRects().length || bounds.width <= 0 || bounds.height <= 0) return false;
        for (let element = frame; element; element = element.parentElement) {
          const style = getComputedStyle(element);
          if (element.hidden || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
        }
        return true;
      });
    }
    function stopCaptchaWatch() {
      clearInterval(captchaWatchTimer);
      captchaWatchTimer = null;
    }
    function startCaptchaWatch() {
      stopCaptchaWatch();
      // A short, modal-only check also catches provider visibility transitions.
      captchaWatchTimer = setInterval(() => {
        if (!dialog.open || !dialog.isConnected) { stopCaptchaWatch(); return; }
        if (!visibleCaptchaChallenge()) return;
        captchaHandoff = true;
        writeSession(pendingKey, '1');
        stopCaptchaWatch();
        dialog.close();
      }, 150);
    }
    function openPopup(trigger) {
      clearTimeout(autoTimer);
      if (dialog.open || visibleCaptchaChallenge()) return;
      captchaHandoff = false;
      opener = trigger || document.activeElement;
      slot.append(panel);
      dialog.showModal();
      document.documentElement.classList.add('crew-order-popup-open');
      dialog.scrollTop = 0;
      hasOpened = true;
      writeSession(seenKey, '1');
      const focusTarget = panel.querySelector('.form-message') || dialog.querySelector('h2');
      focusTarget?.focus({ preventScroll: true });
      startCaptchaWatch();
    }
    function restoreForm() {
      stopCaptchaWatch();
      if (home.isConnected) home.after(panel);
      document.documentElement.classList.remove('crew-order-popup-open');
      if (!captchaHandoff && opener?.isConnected && opener !== document.body) opener.focus({ preventScroll: true });
    }
    function handleTrigger(event) {
      const trigger = event.target.closest('[data-order-popup-trigger]');
      if (!triggers.includes(trigger)) return;
      event.preventDefault();
      openPopup(trigger);
    }
    root.addEventListener('click', handleTrigger);
    dialog.querySelector('[data-order-popup-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', restoreForm);
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const stops = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex="0"]')].filter(element => element.getClientRects().length);
      const first = stops[0];
      const last = stops[stops.length - 1];
      if (event.shiftKey && (document.activeElement === first || !stops.includes(document.activeElement))) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
    const outside = event => {
      const bounds = dialog.getBoundingClientRect();
      return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
    };
    dialog.addEventListener('pointerdown', event => { backdropStart = event.target === dialog && outside(event); });
    dialog.addEventListener('click', event => {
      if (backdropStart && event.target === dialog && outside(event)) dialog.close();
      backdropStart = false;
    });
    form.addEventListener('submit', () => {
      writeSession(pendingKey, dialog.open || captchaHandoff ? '1' : null);
    });
    // Only Shopify-rendered responses count as success or failure; never simulate a submission.
    const message = panel.querySelector('.form-message');
    if (message && readSession(pendingKey)) {
      writeSession(pendingKey, null);
      openPopup(null);
    } else if (!message && !readSession(seenKey) && !/contact/i.test(location.hash) && !location.search.includes('contact_posted')) {
      autoTimer = setTimeout(() => {
        const isEditing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        const contactTop = root.querySelector('.launch-enquiry')?.getBoundingClientRect().top;
        if (!hasOpened && !isEditing && !document.hidden && contactTop > innerHeight * .5) openPopup(null);
      }, 1800);
    }
    dialog._crewPopupCleanup = () => {
      clearTimeout(autoTimer);
      stopCaptchaWatch();
      if (dialog.open) dialog.close();
      restoreForm();
      root.removeEventListener('click', handleTrigger);
    };
  }
  initOrderPopup(document);
  document.addEventListener('shopify:section:load', event => initOrderPopup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelector('[data-order-popup]')?._crewPopupCleanup?.();
  });
})();
